// Glosario de la Ley N.º 21.719 en lenguaje pre-escolar.
// Estructura: what (qué es en simple), why (para qué sirve),
// how (cómo llenar/usar), examples (2-3 casos concretos chilenos),
// notApply (opcional — cuándo NO se aplica), law (referencia).

export const GLOSSARY = {
  rat: {
    term: 'RAT — Registro de Actividades de Tratamiento',
    what: 'Es la lista de todo lo que su empresa hace con datos de personas. Cada vez que guarda, usa o comparte información de un cliente, un colaborador o un proveedor, eso es una "actividad de tratamiento".',
    why: 'La ley exige tener este listado escrito y actualizado. Es la primera prueba que le pediría un fiscalizador de la Agencia. Sin RAT, no puede demostrar que sabe lo que está haciendo con los datos.',
    how: 'Piense en procesos concretos de su empresa: "atender clientes", "pagar sueldos", "hacer marketing", "cámaras de seguridad". Cada uno es UNA actividad. Complete las 6 preguntas del asistente para cada una: nombre, para qué, por qué es legal, qué datos, con quién los comparte, cómo los protege.',
    examples: [
      'Programa de fidelización de clientes (retail): guarda nombres, correos y compras para enviar ofertas personalizadas.',
      'Ficha del empleado (RRHH): guarda RUT, contrato, AFP e Isapre para cumplir obligaciones laborales.',
      'Cámaras de seguridad (operaciones): graba a personas que entran al local para prevenir robos.',
    ],
    law: 'Ley N.º 21.719, art. 15 bis',
  },

  arco: {
    term: 'ARCO+ — Derechos de las personas sobre sus datos',
    what: 'Son los derechos que TODAS las personas tienen sobre los datos que su empresa guarda de ellas. "ARCO+" es la sigla: Acceso, Rectificación, Cancelación, Oposición, más Portabilidad y Objeción a decisiones automatizadas.',
    why: 'Cualquier cliente, empleado o incluso alguien que se inscribió a un newsletter puede pedir: "muéstrenme qué tienen de mí", "corrijan mi teléfono", "bórrenme". Debe responder en 15 días hábiles. Si no lo hace, arriesga multas.',
    how: 'Ofrezca un canal público (correo o formulario) donde las personas puedan escribirle. Cuando llegue una solicitud: (1) verifique quién es, (2) resuelva en 15 días hábiles, (3) deje registro en la bitácora.',
    examples: [
      'Un cliente pide por correo la lista completa de datos que tiene de él → tiene 15 días hábiles para enviársela.',
      'Un ex-empleado pide borrar su foto de la web corporativa → debe hacerlo salvo obligación legal en contra.',
      'Alguien pide dejar de recibir marketing → debe cortar el envío de inmediato.',
    ],
    law: 'Ley N.º 21.719, arts. 5 al 12',
  },

  base_legal: {
    term: 'Base legal (o base de licitud)',
    what: 'Es la razón permitida por la ley que le da derecho a tratar los datos de una persona. Sin base legal, tratar los datos es ilegal, aunque la persona ni se dé cuenta.',
    why: 'La ley no permite recolectar datos "porque sí". Necesita justificar cada actividad con una de seis bases. Elegir la incorrecta invalida todo el tratamiento y expone a multas.',
    how: 'Piense en por qué necesita esos datos y elija la base que mejor calce: si es porque la persona aceptó → consentimiento; si es para cumplir un contrato con ella → contrato; si lo obliga la ley → obligación legal; si es un interés razonable de la empresa → interés legítimo, etc.',
    examples: [
      'Enviar newsletter de ofertas → base "consentimiento" (la persona marcó una casilla).',
      'Enviar el pedido a su casa → base "contrato" (los datos son necesarios para cumplir la compra).',
      'Emitir la boleta al SII → base "obligación legal".',
      'Cámaras de seguridad → base "interés legítimo".',
    ],
    law: 'Ley N.º 21.719, art. 12',
  },

  datos_sensibles: {
    term: 'Datos sensibles',
    what: 'Son los datos que si se filtran pueden hacerle mucho daño a una persona: sobre su salud, ideas políticas, religión, orientación sexual, huellas dactilares, ADN, etc.',
    why: 'La ley les da protección reforzada. Salvo excepciones estrictas, requieren consentimiento explícito por escrito y medidas de seguridad más fuertes. Una filtración de datos sensibles es una infracción gravísima.',
    how: 'Si en el RAT marca que trata datos sensibles: (1) revise que tenga consentimiento explícito o una excepción legal, (2) aplique cifrado, control de acceso estricto y bitácora reforzada, (3) capacite al personal que los maneja.',
    examples: [
      'Historial clínico de un paciente (salud).',
      'Registro biométrico de acceso a las oficinas (huella).',
      'Evaluación de desempeño con datos psicológicos.',
    ],
    law: 'Ley N.º 21.719, art. 2 letra g)',
  },

  titular: {
    term: 'Titular de datos',
    what: 'Es simplemente "la persona a la que pertenecen los datos". Su cliente, su empleado, su proveedor persona natural. NO es la empresa cliente ni el proveedor persona jurídica — solo personas de carne y hueso.',
    why: 'Toda la ley gira en torno a proteger al titular. Todos los derechos ARCO+ los ejerce el titular. Necesita identificar bien quiénes son los titulares de cada actividad del RAT.',
    how: 'En el RAT, seleccione todos los grupos de personas cuyos datos maneja: clientes, empleados, candidatos a empleos, proveedores personas naturales, visitantes de instalaciones o del sitio web, y menores si aplica.',
    examples: [
      'Compras del retail → titulares: clientes.',
      'Contratos de trabajo → titulares: empleados.',
      'Postulaciones a un cargo → titulares: candidatos.',
    ],
    law: 'Ley N.º 21.719, art. 2 letra ñ)',
  },

  dpo: {
    term: 'DPO — Encargado de Protección de Datos',
    what: 'Es la persona responsable de que su empresa cumpla la Ley 21.719. No necesita ser abogado — puede ser alguien de operaciones, TI o legal con dedicación real al tema.',
    why: 'Es la contraparte de la Agencia. Si llega una fiscalización o una denuncia, es a quien buscarán. Además, coordina el trabajo entre RRHH, TI, Marketing y Legal.',
    how: 'Nombre a alguien formalmente (por memo o acta), déle tiempo real para el rol, y publique su correo de contacto en la política de privacidad. Puede ser rol interno o externalizado con un consultor.',
    examples: [
      'Empresa mediana: el Gerente de Operaciones asume el rol de DPO con 8 horas semanales dedicadas.',
      'PyME: el dueño designa a la persona de RRHH como responsable de cumplimiento.',
      'Grupo empresarial: contratan una consultora externa como DPO para todas las filiales.',
    ],
    law: 'Ley N.º 21.719, art. 47',
  },

  dpa: {
    term: 'DPA — Acuerdo de Encargo de Tratamiento',
    what: 'Es un contrato que se firma con cualquier proveedor externo que trate datos de sus clientes o empleados por usted. Ejemplos: la empresa que le hace la nómina, el proveedor de correo, el hosting del sitio web, la contadora externa.',
    why: 'La ley le hace responsable de lo que hagan sus proveedores con los datos que usted les entrega. Sin DPA firmado, si el proveedor filtra los datos, usted responde. El DPA es su "traspaso de responsabilidad" documentado.',
    how: 'Por cada proveedor de su catastro que tenga acceso a datos personales, firme un DPA. Priviax le genera un borrador base. Verifique: (1) qué datos entrega, (2) para qué los usa el proveedor, (3) medidas de seguridad, (4) qué pasa al terminar el contrato.',
    examples: [
      'Software de nómina (Buk, Rankmi, Talana) → DPA firmado.',
      'Google Workspace o Microsoft 365 → DPA (ellos lo ofrecen, hay que aceptarlo).',
      'Contadora externa que ve boletas de honorarios → DPA firmado.',
    ],
    law: 'Ley N.º 21.719, art. 15 bis y 24',
  },

  brecha: {
    term: 'Brecha de seguridad',
    what: 'Es cualquier incidente donde los datos personales quedan expuestos, se pierden o son robados. No importa si fue por un ataque, un error humano o un accidente — cuenta como brecha.',
    why: 'Debe notificar a la Agencia dentro de 72 horas desde que se entera. Y a las personas afectadas si el riesgo es alto. No cumplir el plazo es una de las infracciones más caras.',
    how: 'Cuando pasa algo raro: (1) contenga el problema, (2) evalúe qué datos y cuántas personas se afectaron, (3) documente en la Bitácora de trazabilidad, (4) notifique a la Agencia si aplica, (5) comunique a los afectados si el riesgo lo amerita.',
    examples: [
      'Un notebook con la base de clientes se pierde en un taxi.',
      'Un empleado envía por error una planilla con RUTs y sueldos a la lista completa.',
      'Alguien accede a la base de datos con una contraseña robada.',
    ],
    law: 'Ley N.º 21.719, art. 25',
  },

  dpia: {
    term: 'DPIA — Evaluación de Impacto en Protección de Datos',
    what: 'Es un análisis previo que debe hacer ANTES de arrancar un tratamiento que puede ser riesgoso para las personas: gran cantidad de datos, decisiones automatizadas, cámaras masivas, datos sensibles, etc.',
    why: 'La ley exige detectar riesgos antes, no después de un problema. Sirve para decidir si vale la pena hacerlo, cómo mitigarlo, y para tener evidencia ante fiscalización.',
    how: 'Complete un cuestionario guiado que analiza: (1) tipo y volumen de datos, (2) sensibilidad, (3) probabilidad de daño, (4) medidas de mitigación. Priviax lo automatiza en Fase 4.',
    examples: [
      'Instalar cámaras con reconocimiento facial en un local.',
      'Usar un algoritmo para aprobar o rechazar créditos automáticamente.',
      'Lanzar una app que geolocaliza a los usuarios en tiempo real.',
    ],
    law: 'Ley N.º 21.719, art. 15 ter',
  },

  consentimiento: {
    term: 'Consentimiento',
    what: 'Es el permiso libre, informado, específico e inequívoco que da una persona para que trate sus datos. No sirve una casilla pre-marcada ni un texto larguísimo lleno de trampas.',
    why: 'Cuando su base legal es "consentimiento", si no lo puede demostrar por escrito, el tratamiento es ilegal. Debe poder retirar el consentimiento con la misma facilidad con que lo dio.',
    how: 'Casilla de opt-in NO marcada por defecto, texto claro de qué acepta, para qué finalidad, y quién es el responsable. Guarde evidencia (fecha, IP, versión del texto). Ofrezca un botón/enlace de "retiro" en cada correo o formulario.',
    examples: [
      'Al registrarse en el sitio: "☐ Acepto recibir novedades por correo" (no pre-marcado).',
      'En un formulario papel: casilla firmada específica para uso comercial.',
      'Después: link "Darse de baja" en cada newsletter.',
    ],
    law: 'Ley N.º 21.719, art. 12 letra a) y art. 13',
  },

  trazabilidad: {
    term: 'Registro de accesos y trazabilidad',
    what: 'Es la bitácora que deja huella de quién accedió, modificó o entregó datos personales — dentro y fuera de sus sistemas. Incluye eventos automáticos (ERP, CRM) y manuales (carpetas físicas, planillas).',
    why: 'La ley exige tener registros para poder demostrar que sabe qué pasó con los datos. Ante una brecha o una fiscalización, la trazabilidad es la primera evidencia que se pide.',
    how: 'Priviax registra sus acciones automáticamente. Para eventos fuera de la app (entrega de carpetas, exportaciones), use la pestaña "Eventos manuales". Si tiene logs de otros sistemas, súbalos por CSV en la pestaña correspondiente.',
    examples: [
      'Un empleado consultó la ficha de un cliente el 5 de marzo → registrado por el CRM.',
      'RRHH entregó un expediente físico a un ex-empleado → registro manual.',
      'Se ejecutó una exportación masiva de la base de datos → registrado por el sistema.',
    ],
    law: 'Ley N.º 21.719, art. 14 quáter',
  },

  catastro_sistemas: {
    term: 'Catastro de sistemas',
    what: 'Es la lista de todas las plataformas, herramientas y procesos donde viven datos personales de su empresa. Incluye SaaS (HubSpot, Buk), on-premise, físicos (carpetas de papel) y manuales (planillas, WhatsApp).',
    why: 'No puede proteger lo que no sabe que existe. El catastro es la base para saber qué firmar DPAs, qué sistemas tienen logs, y dónde puede haber riesgos ocultos. Muchas empresas descubren aquí sistemas "en las sombras" que nadie controla.',
    how: 'Registre cada sistema con: nombre, proveedor, tipo (SaaS/físico/manual), país de hosting, ¿tiene logs?, ¿tiene DPA firmado?, responsable interno. Después asocie cada actividad del RAT a los sistemas donde vive.',
    examples: [
      'HubSpot (SaaS, EE.UU., con logs, DPA firmado, responsable: Marketing).',
      'Buk (SaaS, Chile, con logs, DPA pendiente, responsable: RRHH).',
      'Carpeta física de contratos (papel, sin logs, responsable: Legal).',
    ],
    law: 'Ley N.º 21.719, art. 14 quáter · Buena práctica ISO 27001',
  },

  documentos_legales: {
    term: 'Documentos legales de protección de datos',
    what: 'Son los textos que su empresa debe tener publicados (o firmados) para cumplir la ley: política de privacidad, aviso de cookies, cláusulas de consentimiento, avisos ARCO+ y contratos con proveedores (DPAs).',
    why: 'Son la "cara visible" del cumplimiento. Sin ellos publicados en el sitio real (no solo redactados internamente), la ley considera que hay un incumplimiento formal, aunque el resto del proceso esté bien.',
    how: 'Priviax redacta cada documento adaptado a su empresa. Usted revisa, aprueba, y luego marca como "Implementado en producción" con la URL donde efectivamente publicó el texto. La barra de completitud le muestra qué falta.',
    examples: [
      'Política de Privacidad publicada en el pie de miempresa.cl.',
      'Banner de cookies en la portada del sitio con opciones para aceptar/rechazar.',
      'DPA firmado con Buk archivado en la carpeta legal.',
    ],
    law: 'Ley N.º 21.719, arts. 14, 14 bis y 15 bis',
  },

  cookies: {
    term: 'CMP · Banner de Cookies y consentimiento',
    what: 'Es la pequeña ventana que aparece en la parte inferior del sitio web ofreciendo al visitante aceptar, rechazar o personalizar el uso de cookies. Priviax le genera un banner listo para pegar en su sitio y guarda automáticamente cada decisión como evidencia.',
    why: 'La ley exige pedir consentimiento antes de instalar cualquier cookie que no sea estrictamente necesaria (analíticas, publicitarias, redes sociales). Si no lo hace, los datos que recolecte por esas cookies son ilegales. El banner es su prueba concreta de que pidió permiso.',
    how: '(1) Configure el banner en la pestaña "Configuración" — color, textos, categorías activas y URL a su política. (2) Copie el snippet de una línea y péguelo en su sitio web justo antes de </head>. (3) Los consentimientos empiezan a aparecer automáticamente en la pestaña "Consentimientos". (4) Si detecta que su sitio usa Google Analytics o Meta Pixel, active las categorías correspondientes.',
    examples: [
      'Cookie estrictamente necesaria: la que mantiene su carrito de compras — siempre activa, no requiere consentimiento.',
      'Cookie analítica: Google Analytics — requiere consentimiento opt-in del visitante.',
      'Cookie publicitaria: Meta Pixel — requiere consentimiento explícito y separado.',
      'Un visitante hizo clic en "Rechazar opcionales" el 3-agosto-2026 desde IP a1b2c3d4 — evidencia guardada.',
    ],
    law: 'Ley N.º 21.719, arts. 12 y 13',
  },

  diagnostico: {
    term: 'Diagnóstico inicial de cumplimiento',
    what: 'Es un cuestionario guiado que evalúa qué tan preparada está su empresa para la Ley 21.719 hoy. Genera un score de 0 a 100 y un plan de acción priorizado.',
    why: 'Sin saber dónde está parado, es imposible avanzar. El diagnóstico le dice cuáles son los huecos más urgentes y en qué orden atacarlos.',
    how: 'Responda las 20 preguntas del asistente. Si no está seguro, marque "No lo sé" — es válido y penaliza menos que responder "No". El sistema calcula su score y arma un plan de tareas ordenado por prioridad.',
    examples: [
      'Empresa con score 30/100 → tareas urgentes: nombrar DPO, levantar RAT básico.',
      'Empresa con score 70/100 → tareas medias: firmar DPAs pendientes, activar bitácora.',
      'Empresa con score 90/100 → tareas de refinamiento: DPIA en actividades sensibles.',
    ],
    law: 'Buena práctica alineada a la Ley N.º 21.719',
  },

  transferencia_internacional: {
    term: 'Transferencia internacional de datos',
    what: 'Es cuando datos personales salen de Chile hacia otro país, ya sea porque su proveedor tiene servidores en el extranjero o porque comparte información con una filial fuera.',
    why: 'La ley exige garantías especiales cuando los datos salen del país: el destino debe tener nivel adecuado de protección o firmar cláusulas contractuales tipo. No basta con enviar y olvidarse.',
    how: 'En el RAT indique si la actividad implica transferencia (por ejemplo, uso de Google Workspace o AWS). En el catastro marque el país del hosting de cada sistema. Firme DPAs con cláusulas contractuales tipo para países sin nivel adecuado.',
    examples: [
      'Correos alojados en Google Workspace (EE.UU.) → transferencia.',
      'Hosting del sitio en AWS Virginia → transferencia.',
      'Sincronización con filial en Argentina → transferencia.',
    ],
    law: 'Ley N.º 21.719, art. 27',
  },
};
